import axios from "axios";

/**
 * Fetches attendee data from the API
 *
 * The endpoint is public. A signed-in session sets a Bearer token on axios's
 * defaults, and Salesforce answers that token with a 401, so this request
 * drops it (`false` removes a default header in axios).
 */
export const fetchAttendeesFromAPI = async (eventId: string, cancelToken: any) => {
  const endPoint: string = "https://eventdex.my.site.com/services/apexrest/BLN_ASC_GetTables";

  const response = await axios.get(endPoint, {
    params: { eventid: eventId },
    headers: { Authorization: false },
    cancelToken: cancelToken
  });

  return response.data;
};
